import React, { useContext } from 'react';
import Copy from '@components/atoms/copy/copy';
import { useTranslations } from 'next-intl';

import StackViewIcon from '@components/icons/stack-view/stackView';
import ListViewIcon from '@components/icons/list-view/listView';

import { Context } from '../../context/provider';
import StyledViewSwitch from './viewSwitch.style';

const ViewSwitch = () => {
  const { setView, view } = useContext(Context);
  const t = useTranslations();

  return (
    <StyledViewSwitch>
      <div className="view-switch__item">
        <Copy smallThick>{t('archive.stackView')}</Copy>

        <button
          type="button"
          onClick={() => setView('stack')}
          className={`view-switch__button ${view === 'stack' ? 'view-switch__button--active' : ''}`}
        >
          <StackViewIcon className="view-switch__stack-icon" />
        </button>
      </div>

      <div className="view-switch__item">
        <button
          type="button"
          onClick={() => setView('list')}
          className={`view-switch__button ${view === 'list' ? 'view-switch__button--active' : ''}`}
        >
          <ListViewIcon className="view-switch__list-icon" />
        </button>

        <Copy smallThick>{t('archive.listView')}</Copy>
      </div>
    </StyledViewSwitch>
  );
};

export default ViewSwitch;
